module.exports = __webpack_public_path__ + "img/icon-exclamation.285b3211.svg";